export default [
  { key: '1', label: 'Workflow Name', type: 'text', name: 'workflowName', required: true},
];
